import { defineElement, FC, useElement } from '@atomify/hooks';
import { Fragment, h } from '@atomify/jsx';
import { useStore } from '@atomify/kit';
import { BPDFunctionalSvg } from '@atoms/index';
import { propertiesStore, View } from '@features/properties/store';
import { useTranslate } from '@utilities/hooks';

export interface PropertiesBreadcrumbLink {
    text: string;
    url: string;
}

export interface PropertiesBreadcrumbs extends Element {
    links: PropertiesBreadcrumbLink[];
}

const Breadcrumb = ({ text, onClick }: { text: string | Text; onClick?: Function }) => {
    return onClick ? (
        <Fragment>
            <button
                class="u-h6 c-properties-breadcrumb properties-breadcrumb--clickable"
                onClick={onClick}>
                {text}
            </button>
            <span class="u-color--grey-20 properties-breadcrumb__chevron">
                <BPDFunctionalSvg name="arrow-chevron-right" />
            </span>
        </Fragment>
    ) : (
        <span class="u-h6 u-inline-block">{text}</span>
    );
};

const PropertiesHomeBreadcrumb = ({ onClick }: { onClick?: Function }) => (
    <Breadcrumb text={useTranslate('Houses')} onClick={onClick} />
);

const PropertiesBreadcrumbsElement: FC<PropertiesBreadcrumbs> = () => {
    const breadcrumbsWrapper = useElement<HTMLDivElement>('[js-hook-properties-breadcrumbs]');

    const [, subscribeProperties] = useStore(propertiesStore);
    subscribeProperties(({ view }) => renderBreadcrumbs(view), ['view']);

    async function renderBreadcrumbs(view?: View) {
        if (!breadcrumbsWrapper.current || !view) return;

        breadcrumbsWrapper.current.innerHTML = '';
        if (!view.onReturn) {
            breadcrumbsWrapper.current.append(<PropertiesHomeBreadcrumb />);
        } else {
            breadcrumbsWrapper.current.append(<PropertiesHomeBreadcrumb onClick={view.onReturn} />);
            breadcrumbsWrapper.current.append(
                <Breadcrumb text={view.name || view.slug || view.type} />,
            );
        }
    }

    return (
        <div class="c-properties-breadcrumbs" js-hook-properties-breadcrumbs>
            <PropertiesHomeBreadcrumb />
        </div>
    );
};

defineElement('properties-breadcrumbs', PropertiesBreadcrumbsElement);
